import React from "react";

const brands = [
  {
    image: "https://cdn.inika.app/ORm9hXybtGYL4glS8ISosaGoE7U2/image_e029d6c2-d705-4a89-8add-d1959b629126_300x_300.webp",
    link: "https://spleash.com",
    size: "w-24 md:w-32 h-16 md:h-20"
  },
  {
    image: "https://cdn.inika.app/RkiDvsT3Y3TOJo9CP6o5AMsekyF3/Full_Logo_Light_Background.webp",
    link: "https://browniebark.com",
    size: "w-16 md:w-20 h-16 md:h-20"
  },
  {
    image: "https://cdn.inika.app/ItnB69PsjPXxVjmSf9ilYjZLBnt1/DoorhickeyLogo.avif",
    link: "https://doorhickey.com",
    size: "w-24 md:w-32 h-16 md:h-20"
  },
  {
    image: "https://cdn.inika.app/c5dALXJg9TQmPLJgOwcETAomi2K2/Doosra_Logo_-_Wordmark_-_Orange_255.webp",
    link: "https://eatdoosra.com",
    size: "w-24 md:w-32 h-16 md:h-20"
  },
  {
    image: "http://cdn.inika.app/82VGgBrIpmbRY9abT26KeqzVHMm2/join_the_tryb_brown_Positive_logo.avif",
    link: "https://jointhetryb.com",
    size: "w-24 md:w-30 h-16 md:h-20"
  },
  {
    image: "https://cdn.inika.app/iSUwmgKyygWJfB22vON10AQmOvz1/logo-website.png",
    link: "https://wagaroundtown.com",
    size: "w-24 md:w-32 h-16 md:h-20"
  },
  {
    image: "https://cdn.inika.app/jWnEQmwjbjWpl2nWffBDvY0a6xs1/doo_loop_words_no_bkg.png",
    link: "https://thedooloop.com",
    size: "w-24 md:w-32 h-16 md:h-20"
  },
  {
    image: "https://cdn.inika.app/abPxntS8IuZ3KQWBv9lZkQ41NTE3/bee-on-logo.png",
    link: "https://www.drinkbeeon.com",
    size: "w-24 md:w-32 h-16 md:h-20"
  },
  {
    image: "https://cdn.inika.app/ezeuoaSpOeYisPEDibfr7AnP6UD2/slick_logo_ss.png",
    link: "https://www.slickgel.com",
    size: "w-24 md:w-32 h-16 md:h-20"
  },
  {
    image: "https://cdn.inika.app/90p29K7RAsNJZe0RaLBF7Rosniz1/luma-logo-light-large.png",
    link: "https://lumaliving.co",
    size: "w-24 md:w-32 h-16 md:h-20"
  },
  {
    image: "https://cdn.inika.app/rrsR6MjqGYbhP9HdNPO2tq6XUQJ3/footer_img_big.png",
    link: "https://heysnaxy.com",
    size: "w-24 md:w-32 h-16 md:h-20"
  }
];

const SocialProofSection = () => {
  return (
    <section className="py-16 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4">
        <h3 className="text-center text-lg text-gray-400 mb-12">Trusted by 15+ growing businesses</h3>
        
        {/* Infinite Scroll Container */}
        <div className="overflow-hidden">
          <div className="flex animate-infinite-scroll">
            {/* First set of brands */}
            <div className="flex space-x-8 md:space-x-12 flex-shrink-0 pr-8 md:pr-12">
              {brands.map((brand, index) => (
                <div
                  key={`first-${index}`}
                  className="flex-shrink-0 group"
                >
                  <a
                    href={brand.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block grayscale hover:grayscale-0 transition-all duration-300 opacity-60 hover:opacity-100 transform hover:scale-110 hover:shadow-lg hover:shadow-purple-500/20 p-4 rounded-lg relative"
                  >
                    {/* Highlighting background */}
                    <div className="absolute inset-0 bg-gradient-to-r from-purple-500/10 via-blue-500/10 to-purple-500/10 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                    
                    <img 
                      src={brand.image} 
                      alt="brand" 
                      className={`${brand.size} object-contain filter hover:drop-shadow-lg relative z-10`} 
                    />
                  </a>
                </div>
              ))}
            </div>
            
            {/* Second set of brands (duplicate for seamless loop) */}
            <div className="flex space-x-8 md:space-x-12 flex-shrink-0">
              {brands.map((brand, index) => (
                <div
                  key={`second-${index}`}
                  className="flex-shrink-0 group"
                >
                  <a
                    href={brand.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block grayscale hover:grayscale-0 transition-all duration-300 opacity-60 hover:opacity-100 transform hover:scale-110 hover:shadow-lg hover:shadow-purple-500/20 p-4 rounded-lg relative"
                  >
                    {/* Highlighting background */}
                    <div className="absolute inset-0 bg-gradient-to-r from-purple-500/10 via-blue-500/10 to-purple-500/10 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                    
                    <img 
                      src={brand.image} 
                      alt="brand" 
                      className={`${brand.size} object-contain filter hover:drop-shadow-lg relative z-10`} 
                    />
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .animate-infinite-scroll {
          animation: infinite-scroll 20s linear infinite;
          width: fit-content;
        }
        
        .animate-infinite-scroll:hover {
          animation-play-state: paused;
        }
        
        @keyframes infinite-scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(calc(-50% - 1rem));
          }
        }
        
        @media (min-width: 768px) {
          @keyframes infinite-scroll {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(calc(-50% - 1.5rem));
            }
          }
        }
      `}</style>
    </section>
  );
};

export default SocialProofSection; 